import React from 'react';
import { IconButton, Portal, Button } from '@mui/material';
import { Close, ErrorOutline } from '@mui/icons-material';
import { PropTypes } from 'prop-types';

import '../common.scss';
import './HorizontalPanel.scss';

export default function AlertHighlightPanel({
  container,
  close,
  dismissAlert,
  alert,
  showAllAlerts,
}) {
  const displayText = alert.text.length > 100 ? `${alert.text.substring(0, 100)}...` : alert.text;
  return (
    <Portal container={container.current}>
      <div className="alert-highlight horizontal-panel">
        <ErrorOutline htmlColor="#FFFFFF" />
        <div
          className="alert-text"
          role="button"
          onClick={showAllAlerts}
          onKeyDown={showAllAlerts}
          tabIndex={0}
        >
          {displayText}
        </div>
        <div className="responsive-fill" />
        <Button onClick={() => dismissAlert(alert.id)}>Dismiss</Button>
        <IconButton onClick={close}>
          <Close />
        </IconButton>
      </div>
    </Portal>
  );
}

AlertHighlightPanel.propTypes = {
  container: PropTypes.object.isRequired,
  close: PropTypes.func.isRequired,
  alert: PropTypes.object.isRequired,
  dismissAlert: PropTypes.func.isRequired,
  showAllAlerts: PropTypes.func.isRequired,
};
